export default class PetDetailsForm {}

PetDetailsForm.Breed = 'BREED';
PetDetailsForm.Sex = 'SEX';
PetDetailsForm.BirthDate = 'BIRTH_DATE';
PetDetailsForm.Species = 'SPECIES';
PetDetailsForm.Weight = 'WEIGHT';
